import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@features/auth/data-access/auth.service';

export const scopeGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const requiredScopes = (route.data?.['scopes'] as readonly string[] | undefined) ?? [];
  if (requiredScopes.length === 0) {
    return true;
  }
  const granted = authService.scopes();
  const allowed = requiredScopes.every((scope) => granted.includes(scope));
  if (allowed) {
    return true;
  }
  return router.createUrlTree(['/home']);
};
